<template>
    <Card>
        <div>
            <div class="multiple">
                <div class="child-div">申请时间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>

                </RadioGroup>
                <Button class='ivu-btn-circle' style="margin-left: 30px" type="primary" @click="search">搜索</Button>
                <Button class='ivu-btn-circle' style="margin-left: 20px" @click="modal = true">提现</Button>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">

                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
            </div>

            <!-- 提现申请 -->
            <Modal v-model="modal" width="500" title="提现申请">
                <Form :label-width="120">
                    <FormItem label="账户余额">
                        <span>{{medium.balance}}元</span>
                    </FormItem>
                    <FormItem label="提现金额">
                        <Input placeholder="输入提现金额" v-model="withdrawForm.money" style="width: 150px"></Input>
                    </FormItem>
                    <FormItem label="支付宝姓名">
                        <Input placeholder="输入提现支付宝姓名" v-model="withdrawForm.realname" style="width: 150px"></Input>
                    </FormItem>
                    <FormItem label="支付宝账号">
                        <Input placeholder="输入提现支付宝账号" v-model="withdrawForm.account" style="width: 150px"></Input>
                    </FormItem>
                </Form>
                <div slot="footer">
                    <Button type="primary" @click="withdrawSubmit">提交</Button>
                    <Button type="default" @click="modal = false">取消</Button>
                </div>
            </Modal>
        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
    import {getMediumWithdrawList,withdrawSubmit} from "../../api/finance"
    import {getMedium} from "../../api/runSet";


    export default {
        name: "MediumWithdraw",
        components: {},

        data() {
            return {
                modal: false,
                count: 0,
                page: 1,
                timePeriod: '0',
                timePeriodDate: '',
                datas: [ ],
                medium: {balance: 0},
                withdrawForm: {
                    money: 0,
                    realname: 0,
                    account: 0,
                },
                columns: [
                    {
                        "title": "id",
                        "key": "id",
                        width: 50,
                        align: 'center'
                    },
                    {
                        "title": "提现金额",
                        "key": "money",
                        width: 250,
                        align: 'center'
                    },
                    {
                        "title": "提现支付宝姓名",
                        "key": "realname",
                        "width": 250
                    },
                    {
                        "title": "提现支付宝账号",
                        "key": "account",
                        "width": 250
                    },
                    {
                        "title": "申请时间",
                        "key": "created_at",
                        "width": 250,
                        "sortable": true
                    },
                    {
                        "title": "状态",
                        "key": "status_name",
                        align: 'center'
                    }
                ],
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
            this.getList();
        },
        methods: {

            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            async loadData() {
                let that = this;
                let data = {
                    token: that.token,
                };
                let res = await getMedium(that, data);
                if (res.code == 1) {
                    that.medium = res.data.item;
                }
            },
            async getList() {
                let that = this;
                let data = {
                    token: that.token,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                    name: that.name
                };
                let res = await getMediumWithdrawList(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                    that.count = res.count;
                }
            },
            search() {
                this.page = 1;
                this.getList();
            },
            changePage(e) {
                this.page = e;
                this.getList()
            },
            // 提现
            withdrawSubmit() {
                let that = this;
                that.$Modal.confirm({
                    title: '确认提现吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, withdrawForm:that.withdrawForm}
                            let res = await withdrawSubmit(that, data);
                            if (res.code == 1) {
                                that.$Message.success(res.msg);
                            }
                            that.modal = false;
                            that.loadData();
                            that.getList();
                        }, 500)
                    }
                })
            }
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .flex_between p{
        display: inline-block;
    }
</style>
